import { USER_COLORS } from "../constants/colors";
import { DEFAULT_GROUP_ID } from "../constants/group";

export const addColorToUsers = (users: User[], usersByGroupId: Dic<number[]>) =>
  users?.map((user: User) => ({
    ...user,
    color: getUserColor(user.id, usersByGroupId[user?.group?.id ?? DEFAULT_GROUP_ID], getGroupColor(user.group)),
  })) ?? [];

export const getGroupColor = (group: GroupType | undefined) => {
  if (!group) return "blue";
  return group.colorPalette.toLowerCase();
};

export const getUserColor = (userId: number, users: number[], groupColor: string) => {
  const index = users.indexOf(userId);

  return USER_COLORS[groupColor][`${groupColor}${index + 1}`];
};

export const mapUsersByGroupId = (users: User[]) =>
  users?.reduce((curr: Dic<number[]>, next: User) => {
    const key = next?.group?.id ?? DEFAULT_GROUP_ID;
    return { ...curr, [key]: [...(curr[key] ?? []), next.id] };
  }, {}) ?? [];

export const mapUsersById = (users: UserWithColor[]) =>
  users?.reduce((curr: Dic<User>, next: User) => ({ ...curr, [next.id]: { ...next } }), {}) ?? [];

export const mapUsersByLabel = (users: UserWithColor[]) =>
  users?.reduce((curr: Dic<User>, next: User) => ({ ...curr, [next.alias ?? next.username]: { ...next } }), {}) ?? [];
